import { render } from "./TimeInfo.vue?vue&type=template&id=45cb0914"
import script from "./TimeInfo.vue?vue&type=script&lang=js"
export * from "./TimeInfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__